import { render, staticRenderFns } from "./ListFieldtype.vue?vue&type=template&id=58f43d54&"
import script from "./ListFieldtype.vue?vue&type=script&lang=js&"
export * from "./ListFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports